import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Pages.css';

function Services() {
  const services = [
    {
      title: 'Web Services',
      icon: '🌐',
      description:
        'Custom web applications, SEO optimization, responsive design, and digital strategy to establish and grow your online presence.',
    },
    {
      title: 'Software Development',
      icon: '⚙️',
      description:
        'Full-stack development, APIs, data pipelines, and custom software solutions tailored to your specific needs.',
    },
    {
      title: 'AI & Automation',
      icon: '🤖',
      description:
        'Intelligent automation, workflow optimization, and AI-powered tools to streamline operations and reduce manual work.',
    },
    {
      title: 'Consulting',
      icon: '💼',
      description:
        'Technical strategy, architecture design, digital transformation guidance, and expert advice for technology decisions.',
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    const sections = document.querySelectorAll('.animate-on-scroll');
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="container services-page">
      <h1 className="page-title">Services</h1>
      <p className="page-intro">
        We offer a comprehensive suite of services designed to elevate your technology and drive
        growth.
      </p>

      <section className="services-grid animate-on-scroll" aria-label="Our Services">
        {services.map((service, idx) => (
          <article key={idx} className="card service-card" style={{ '--item-index': idx }}>
            <span className="service-icon">{service.icon}</span>
            <h2>{service.title}</h2>
            <p>{service.description}</p>
          </article>
        ))}
      </section>

      {/* CTA Section */}
      <section className="home-cta-section animate-on-scroll" aria-labelledby="cta-heading">
        <div className="container">
          <div className="card cta-card">
            <h2 id="cta-heading">Ready to Get Started?</h2>
            <p>Let's discuss how we can help transform your business.</p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-primary">
                Contact Us
              </Link>
              <Link to="/projects" className="btn btn-secondary">
                View Our Work
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Services;
